import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Package, ShoppingCart, ClipboardList, User } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

const BottomNav = () => {
  const { itemCount } = useCart();
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  const navItems = [
    { to: '/', icon: Home, label: 'Inicio' },
    { to: '/productos', icon: Package, label: 'Productos' },
    { to: '/carrito', icon: ShoppingCart, label: 'Carrito', badge: itemCount },
    ...(isAuthenticated ? [
      { to: '/pedidos', icon: ClipboardList, label: 'Pedidos' },
      { to: '/cuenta', icon: User, label: 'Cuenta' },
    ] : [
      { to: '/login', icon: User, label: 'Ingresar' },
    ]),
  ];

  // Ocultar en ciertas páginas
  const hiddenPaths = ['/checkout', '/login', '/register'];
  if (hiddenPaths.some(path => location.pathname.includes(path))) {
    return null;
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 pb-safe shadow-[0_-4px_20px_rgba(0,0,0,0.05)]">
      <div className="flex items-center justify-around h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `
              flex flex-col items-center justify-center
              flex-1 h-full
              gap-1
              transition-colors duration-200
              touch-manipulation
              ${isActive 
                ? 'text-primary' 
                : 'text-gray-500 hover:text-text'
              }
            `}
          >
            <div className="relative">
              <item.icon 
                size={24} 
                strokeWidth={2}
                className="transition-transform duration-200"
              />
              {item.badge > 0 && (
                <span className="absolute -top-2 -right-2 w-4 h-4 bg-primary text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                  {item.badge > 9 ? '9+' : item.badge}
                </span>
              )}
            </div>
            <span className="text-[10px] font-medium">
              {item.label}
            </span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
